import { useMemo } from 'react'

import { usePersonByIdQuery } from '../api/person.api'
import SinglePersonDto from '../model/single-person/SinglePersonDTO'

const useGetPersonById = (personId: string) => {
  const { data, isLoading, isError, isSuccess } = usePersonByIdQuery(personId)

  const modeledPerson = useMemo(() => {
    if (data) {
      return new SinglePersonDto(data)
    }
    return
  }, [data])

  return {
    data,
    isLoading,
    isSuccess,
    isError,
    modeledPerson,
  }
}

export default useGetPersonById
